export const colors = {
  blacks: ['#000000', '#333333'],
  blues: ['#254D71', '#36658F', '#4B7DAB', '#80A9CF', '#A9CAE8', '#EFF5FA'],
  bluesCal: ['#0B58CE'],
  bluesV2: ['#EFF5FF', '#DCEAFF', '#B5D0FB', '#9EC5FB', '#80B2FF', '#4484E4', '#1D60C7', '#094297', '#001636'],
  browns: [
    '#F4E9E6',
    '#DCC0B7',
    '#BD9A8F',
    '#734B3F',
    '#391F17',
    '#2D150D',
    '#200C05',
    '#1D0A03',
    '#0D0300',
    '#0D0300',
  ],
  cream: ['#FFF9EF', '#FDF8EE', '#FDF8EE', '#FDEDCF', '#FFE7BF', '#F1D09A', '#EFC57E', '#8D6A31', '#513912'],
  glassLight: [
    '#FFF9EF0D',
    '#FFF9EF1A',
    '#FFF9EF33',
    '#FFF9EF4D',
    '#FFF9EF73',
    '#FFF9EF99',
    '#FFF9EFB2',
    '#FFF9EFD9',
    '#FFF9EFF2',
  ],
  glassDark: [
    '#0D03000D',
    '#0D03001A',
    '#0D030033',
    '#0D03004D',
    '#0D030073',
    '#0D030099',
    '#0D0300B2',
    '#0D0300D9',
    '#0D0300F2',
  ],
  neutralDark: ['#F2EDE3', '#E6E0D7', '#CCC7BF', '#B3AEA7', '#8C8983', '#666460', '#4D4B48', '#262524', '#0D0D0C'],
};
